<script lang="ts">
    import { type NodeContent } from '$lib/bbcode/parser/types';
    import BBCodeNode from './BBCodeNode.svelte';

    export let nodes: NodeContent[];
</script>

{#each nodes as node}
    <BBCodeNode {node} let:slotName let:slotContent>
        <slot {slotName} {slotContent} />
    </BBCodeNode>
{/each}
